import React, {useState, useRef, useContext} from "react";

import "./style.scss";
import {AppContext} from "../AppContext";

export default function LongTextTooltiper(props) {
    const ref = useRef(null);
    const [longTextPosition, setLongTextPosition] = useState(undefined);
    const appContext = useContext(AppContext);

    function showLongText(hideAfter) {
        if (!longTextPosition && ref.current.offsetWidth <= ref.current.scrollWidth) {
            const boundingClientRect = ref.current.getBoundingClientRect();

            const newLongTextPosition = appContext.direction === "rtl" ? {
                    top: boundingClientRect.top,
                    right: window.innerWidth - boundingClientRect.right
                }
                :
                {
                    top: boundingClientRect.top,
                    left: boundingClientRect.left
                };

            setLongTextPosition(newLongTextPosition);

            if (hideAfter)
                setTimeout(hideLongText, hideAfter);
        }
    }

    function hideLongText() {
        setLongTextPosition(undefined);
    }

    function onMouseEnter(e) {
        showLongText();
    }

    function onTouchStart(e) {
        showLongText(2500);
    }

    function onMouseOut(e) {
        hideLongText();
    }

    return (
        <span className="long-text-tooltiper">
            <span className="short-text"
                  ref={ref}
                  onMouseEnter={onMouseEnter}
                  onMouseLeave={onMouseOut}
                  onTouchStart={onTouchStart}
            >
                {props.children}
                {
                    longTextPosition ?
                        (
                            <span className="long-text"
                                  style={{
                                      top: longTextPosition.top,
                                      right: longTextPosition.right,
                                      left: longTextPosition.left,
                                      backgroundColor: props.backgroundColor
                                  }}>
                            {props.children}
                        </span>
                        )
                        :
                        null
                }
            </span>
        </span>
    );
}